import { render } from "./NavWrapper.vue?vue&type=template&id=5529438a&ts=true"
import script from "./NavWrapper.vue?vue&type=script&lang=ts"
export * from "./NavWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__